"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
exports.WebRouter = (props) => {
    function content() {
        return (react_1.default.createElement(react_router_dom_1.Switch, null, props.rotas.map((route, index) => react_1.default.createElement(react_router_dom_1.Route, { key: index, exact: route.exactPath, path: route.path, component: route.component }))));
    }
    if (props.hashRouter) {
        return (react_1.default.createElement(react_router_dom_1.HashRouter, null, content()));
    }
    else {
        return (react_1.default.createElement(react_router_dom_1.BrowserRouter, null, content()));
    }
};
